export const WINDOW_RELOAD = 'WINDOW_RELOAD';


// WEBPACK FOOTER //
// ./src/types/reloadTypes.js